<template>
    <div
        class="drop-line"
        :class="{
            'drop-line--animated': animated,
            'drop-line--cart': fromCart,
            'drop-line--invalid': invalidDropsPromo,
        }">
        <div class="drop-line__part">
            <span class="color-accent text_9" v-if="$device.isMobile && fromCart">drop</span>
            <span class="color-accent text_11" v-else>{{ drop.name }}</span>
            <span class="text_9 flex-c" v-if="drop.promocode">
                <svg-icon name="attantion" width="8" height="8" /> {{ $t("promo_required") }}
            </span>
        </div>
        <template v-if="animated">
            <div class="drop-line__part" v-for="i in 12" :key="i">
                <span class="color-accent text_11">{{ drop.name }}</span>
                <span class="text_9 flex-c" v-if="drop.promocode">
                    <svg-icon name="attantion" width="8" height="8" /> {{ $t("promo_required") }}
                </span>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    name: "DropLine",
    props: {
        drop: {
            type: Object,
        },
        animated: {
            type: Boolean,
            default: false,
        },
        fromCart: {
            type: Boolean,
            default: false,
        },
        invalidDropsPromo: {
            type: String,
            default: "",
        },
    },
};
</script>
<style lang="less">
.drop-line {
    display: flex;
    &--invalid {
        .text_9 {
            color: @red2;
        }
    }
    &--animated {
        margin: 0 -32px;
        margin-bottom: 40px;
        white-space: nowrap;
        overflow: hidden;
        span:last-child {
            &:after {
                content: "/";
                display: block;
                margin: 0 8px;
                color: @text_3;
            }
        }
        @media @sm {
            margin: 0 -16px;
            margin-bottom: 25px;
            margin-top: 0px;
        }
    }
    &--cart {
        span {
            &:first-child {
                &:after {
                    display: none !important;
                }
            }
        }
    }
    &__part {
        display: flex;
        .drop-line--animated & {
            animation: slide 5s linear infinite;
        }

        svg {
            margin-right: 4px;
        }
        span {
            display: flex;
            &:first-child {
                &:after {
                    content: "/";
                    display: block;
                    margin: 0 8px;
                    color: @text_3;
                }
            }
        }
    }
}
@keyframes slide {
    to {
        transform: translateX(-100%);
    }
}
</style>
